import { render, staticRenderFns } from "./ColumnsGroup.vue?vue&type=template&id=9d1d261a&scoped=true&"
import script from "./ColumnsGroup.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ColumnsGroup.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ColumnsGroup.vue?vue&type=style&index=0&id=9d1d261a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1d261a",
  null
  
)

export default component.exports